<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{ 'New note'|translate }}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <form [formGroup]="noteForm" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto">
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Title'|translate}}</mat-label>
                    <input name="title" formControlName="title" matInput required>
                    <mat-error>{{'Title is required!'|translate}}</mat-error>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Description'|translate}}</mat-label>
                    <textarea matInput
                              formControlName="description"
                              class="textarea"
                              required
                              cdkTextareaAutosize
                              #autosize="cdkTextareaAutosize"
                              cdkAutosizeMinRows="5"
                              cdkAutosizeMaxRows="10"
                    ></textarea>
                    <mat-error>{{'Description is required!'|translate}}</mat-error>
                </mat-form-field>
            </div>
        </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Cancel">
            {{'Cancel'|translate}}
        </button>
        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close(noteForm)"
                aria-label="Save">
            {{'Create'|translate}}
        </button>

    </div>
</div>
